module.exports = {
	"featuredAuctionsHeader": "Enchères en vedette",
	"featuredAuctionsHeaderSmall": "En cours et à venir.",
	"featuredAuctionsMoreBtn": "Enchères à venir en vedette",
	"featurette1Header": "Acheter et vendre sur $t(siteName).",
	"featurette1HeaderMuted": "Un seul arrêt où encanteurs et acheteurs se rencontrent.",
	"featurette1Lead": "Les encanteurs peuvent rejoindre plus d'acheteurs intéressés à leurs items et les acheteurs ont accès à des encans partout sur la planète.",
	"featurette2Header": "Plus d'acheteurs.",
	"featurette2HeaderMuted": "Plus d'offres.",
	"featurette2Lead": "Augmentez la valeur et le retour sur vos ventes en rejoignant plus d'enchérisseurs pour vos encans.",
	"featurette3Header": "Des enchères à travers le monde.",
	"featurette3HeaderMuted": "Accès mondial aux articles.",
	"featurette3Lead": "Misez facilement sur des articles partout sur la planète. Enlevez la barrière qui vous empêche de rejoindre une plus large clientèle.",
	"earlyAccess": "Enregistrez-vous maintenant et commencez à vendre et à publier vos encans sur notre plateforme.",
	"organizationCount": "Répertoire de __organizationCount__ encanteurs et vendeurs.",
	"carousel": {
		"signUpToday": "Enregistrez-vous maintenant",
		"becomeSeller": "Devenez un encanteur enregistré maintenant",
		"registerNowSeller": "Enregistrez-vous maintenant pour lister vos encans et vos lots sur $t(siteName)."
	},
	"imgAlt": {
		"auction": "Dessin d'événement d'encan",
		"auctioneer": "Encanteur",
		"hammer": "Marteau d'encanteur",
		"paddles": "Carte de mise",
		"globe": "Globe mondial"
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/home.json5
// module id = 1986
// module chunks = 6